// domestic.js

const domestic = {
  id: 2,
  title: "Domestic Travel",
  questions: [
    {
      question: "Do you offer customized domestic tour packages?",
      answer:
        "Yes, we create fully customized domestic travel packages based on your destination preferences, budget, and travel duration.",
    },
    {
      question: "Which domestic destinations are most popular?",
      answer:
        "Popular destinations include Kashmir, Himachal, Kerala, Goa, Rajasthan, Northeast India, Andaman, and Ladakh.",
    },
    {
      question: "Can you arrange transportation and hotels together?",
      answer:
        "Yes, we provide complete travel arrangements including hotels, flights, trains, local transport, and sightseeing.",
    },
  ],
};

export default domestic;